/**
 * Cell keys the booked-work row variants populate. Screens own their column
 * definitions (label, order, flex) but must use these keys to line up with
 * what the variants emit. Keys a screen leaves out simply do not render.
 */
export const BookedWorkCell = {
  Ref: "ref",
  BookedBy: "who",
  When: "when",
  SitePlot: "sitePlot",
} as const;

export type BookedWorkCellKey =
  (typeof BookedWorkCell)[keyof typeof BookedWorkCell];
